import { menuStructure } from '../config/menuStructure';
import { readPageViewPreference, writePageViewPreference } from './pageViewPreferences';

const LAST_LIST_KEY = 'last-list-page';

function menuLabelForPath(items, pathname) {
  for (const item of items || []) {
    if (item?.path === pathname && item.label) return item.label;
    if (item?.children) {
      const found = menuLabelForPath(item.children, pathname);
      if (found) return found;
    }
  }
  return null;
}

export function rememberLastListPage(pathname) {
  if (!pathname || pathname === '/') return;
  const label = menuLabelForPath(menuStructure, pathname);
  if (!label) return;
  writePageViewPreference(LAST_LIST_KEY, { path: pathname, label });
}

export function readLastListPage() {
  const saved = readPageViewPreference(LAST_LIST_KEY);
  if (!saved.path || saved.path === '/' || !saved.label) return null;
  return { path: saved.path, label: saved.label };
}
